import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import styled from 'styled-components';
import socket from "../../../Socket";
import storage from "../../../Storage";
import { decode, encode, getElement, sendNotfication, isEmail, Event, DEVELOPMENT, wait, randomString } from "../../../Helper";
import C from "../../../Constant";
import axios from 'axios';
import { Link } from 'react-router-dom';

const StyledModal = styled(Modal)`
   .modal-content {
    background-color: rgb(35 38 38);
    color: white;
    border-radius: 18px;
    overflow: hidden;
    display:flex;
    flex-direction:row;
    z-index: 9999;

    @media(max-width:340px){
      margin:5px !important;
    }
  }
    .modal-md{
    @media(min-width:640px){
      max-width:50rem !important;
    }
    }  
`;

const ModalHeader = styled.div`
  background-color transparent;
  // padding: 10px;
  padding-left:15px;
  padding-right:15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  color: white;
  font-size: 24px;
  cursor: pointer;
  display: flex;
  justify-content: flex-end;

  @media(max-width:640px){
  display:none;
  }
`;

const ModalBody = styled(Modal.Body)`
@media(max-width:400px){
  padding:0px;
  padding-top:10px;
  }
`;

const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const StyledInput = styled.input`
  background-color: #1E2121;
  border: 1px solid #3A4142;
  border-radius: 7px;
  color: white;
  padding: 7px;
  font-size:clamp(5px,3vw,12px);
  &::placeholder {
    color: #9CA3AF;
    font-weight:500;
  }
  &:focus {
    outline: none;
    border-color: #83EA77;
    box-shadow: 0 0 0 0.5px #83EA77;
  }
`;

const StyledInputss = styled.input`
  background-color: #1E2121;
  border: 1px solid #3A4142;
  border-radius: 7px;
  color: white;
  padding: 7px;
  font-size:clamp(5px,3vw,12px);
  &::placeholder {
    color: #9CA3AF;
    font-weight:500;
  }
  &:focus {
    outline: none;
    border-color: #83EA77;
    box-shadow: 0 0 0 0.5px #83EA77;
  }
    flex: 1;
    padding-right: 110px; /* to give room for the button inside */
    height: 40px;
`;

const Labeltext = styled.div`
  color: #696F79;
  font-size: 14px;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
  justify-content: center;
`;

const Button = styled.button`
   padding: 10px 20px;
  border-radius: 7px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
`;

const SignUpButton = styled(Button)`
   background-image: linear-gradient(90deg, rgb(36, 238, 137), rgb(159, 232, 113));
  box-shadow: rgba(35, 238, 136, 0.3) 0px 0px 12px, rgb(29, 202, 106) 0px -2px inset;
  color: black;
  border: none;
  width: 100%;
  max-width: 100%;
  max-height:100%;
  margin-top:10px;

  &:hover {
    background-color: #7c3aed;
  }
`;
// const SendOtpButton  = styled(Button)`
//    background-image: linear-gradient(90deg, rgb(36, 238, 137), rgb(159, 232, 113));
//     box-shadow: rgba(35, 238, 136, 0.3) 0px 0px 12px, rgb(29, 202, 106) 0px -2px inset;
//     color: black;
//     border: none;
 

//   &:hover {
//     background-color: #7c3aed;
//   }
// `;
const SendOtpButton = styled.button`
    position: absolute;
    right: 5px;
    top: 50%;
    transform: translateY(-50%);
    height: 30px;
    padding: 0 10px;
    font-size: 0.9rem;
    border: none;
    color: black;
    border-radius: 4px;
    cursor: pointer;
     background-image: linear-gradient(90deg, rgb(36, 238, 137), rgb(159, 232, 113));
  box-shadow: rgba(35, 238, 136, 0.3) 0px 0px 12px, rgb(29, 202, 106) 0px -2px inset;
`;

const SignInButton = styled(Button)`
    color: rgb(36 238 137);
  background:transparent;
  border:none;
`;

const StyledSignUpButton = styled.div`

  background-color: #45B70C;
  color: white;
  border: none;
  border-radius: 500px;
  padding: 10px 24px;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 1px;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space:nowrap;

 
`;

const CloseButtonNew = styled.div`
position:absolute;
top:10px;
right:10px;
font-size:18px;
display:none;

@media(max-width:640px){
display:block;
}
`

const PhoneInputWrapper = styled.div`
    display: flex;
    align-items: center;
    position: relative;
`;



class ForgetPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLogged: storage.getKey('logged'),
            show: this.props.show ? this.props.show : false,
            username: '',
            phone: '',
            email: '',
            password: '',
            confirmPassword: '',
            referral: this.props.referral || '',
            ruleChecked: false,
            ruleChecked18: false,
            submitted: false,
            disabled: false,
            effect: 'zoomIn',
            isOtp: false,
            otp: '',
            loading:false,
            countryCode: "+977",
            countryCodeData: [],
        };
    }

    componentDidMount() {
        this.countryCodeLoad();
        socket.on(C.EDIT_FORGET_PASSWORD, data => this.setRegister(decode(data)));
        Event.on('register_form', () => {
            this.handleShow();
        });
    }

     countryCodeLoad = async () => {
        try {
            const response = [
            
            {
                "name": "Nepal",
                "dial_code": "+977",
                "code": "NP",
                "flag": "🇳🇵"
            },
            {
                "name": "Pakistan",
                "dial_code": "+92",
                "code": "PK",
                "flag": "🇵🇰"
            },
            {
                "name": "Bangladesh",
                "dial_code": "+880",
                "code": "BD",
                "flag": "🇧🇩"
            }
            ];

            this.setState({ countryCodeData: response });
        } catch (error) {
            console.error("Error fetching country codes:", error);
        }
    };

    setRegister = (data) => {
        console.log(data)
        if (data.error) {
            this.setState({ disabled: false, submitted: false });
            return sendNotfication(data.error, 'success', 'bottom-left');
        }

        if (data.status) {

            console.log("datataaaa", data)
             sendNotfication('Successfully changed, Please loing...', 'success', 'bottom-left');
             Event.emit('login_form');
        }
    };

    handleShow = () => {
        this.setState({ show: true, effect: 'zoomIn' });
    }

    handleCloseF = () => {
        this.setState({ show: false, effect: 'zoomOut', disabled: false, submitted: false, ruleChecked: false,ruleChecked18: false });
    }

  
   handleForgetSubmit  =  async (e) => {
    var verified
        e.preventDefault();
        this.setState({ submitted: true, disabled: true });
        
        const { phone, password, confirmPassword, otp } = this.state;
    

        if(!phone){
            sendNotfication('Please enter a phone number', 'error', 'bottom-left');
            this.setState({ disabled: false });
            return;
        }

        if(isNaN(phone)){
            sendNotfication('Please enter a valid phone number', 'error', 'bottom-left');
            this.setState({ disabled: false });
            return;
        }

        if(phone.length < 10 || phone.length > 15){
            sendNotfication('Please enter a valid phone number', 'error', 'bottom-left');
            this.setState({ disabled: false });
            return;
        }
        
        if (!password) {
            sendNotfication('Please enter a password', 'error', 'bottom-left');
            this.setState({ disabled: false });
            return;
        }
        if (!confirmPassword) {
            sendNotfication('Please enter a confirm password', 'error', 'bottom-left');
            this.setState({ disabled: false });
            return;
        }
        if (password !== confirmPassword) {
            sendNotfication('Passwords do not match', 'error', 'bottom-left');
            this.setState({ disabled: false });
            return;
        }        

        socket.emit(C.EDIT_FORGET_PASSWORD, encode({
            countryCode: this.state.countryCode,
            phone: phone,
            password: password,
        }));
        this.handleCloseF()
    }

    handleInputChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    login = () => {
        this.handleCloseF();
        Event.emit('login_form');
    }

    handleSendOtp = async () => {
        const { phone } = this.state;
    
        if(!phone){
            sendNotfication('Please enter a phone number', 'error', 'bottom-left');
            this.setState({ disabled: false });
            return;
        }

        if(isNaN(phone)){
            sendNotfication('Please enter a valid phone number', 'error', 'bottom-left');
            this.setState({ disabled: false });
            return;
        }

        if(phone.length < 10 || phone.length > 15){
            sendNotfication('Please enter a valid phone number', 'error', 'bottom-left');
            this.setState({ disabled: false });
            return;
        }

        this.setState({
            loading: true
        })
    
        try {
            const response = await fetch(`https://api.trubetx.com/send-otp`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ phone: phone, countryCode: this.state.countryCode, type: 'forget' })
            });
    
            const data = await response.json();

            this.setState({
            loading: false
             })
    
            if (data.status) {
                console.log(data);
                this.setState({ isOtp: true });
                sendNotfication('OTP sent successfully!', 'success', 'bottom-left');
            } else {
                sendNotfication(data.message || "Failed to send OTP", 'error', 'bottom-left');
            }            
        } catch (err) {
            console.error("Error sending OTP:", err);
            alert("Something went wrong while sending OTP");
        }
    };
    

    render() {
        const { show, phone, password,confirmPassword, disabled, isOtp, otp, loading } = this.state;

        return (
            <>
            {storage.getKey('logged') ? false :  <div onClick={this.handleShow} className='' style={{cursor: "pointer"}}>
            Forgot password?
                </div>}
               
                <StyledModal
                    size="md"
                    centered
                    show={storage.getKey('logged') ? false : show}
                    onHide={this.handleCloseF}
                    aria-labelledby="register-modal"
                    className={`animated ${this.state.effect}`}
                >

                <div className='login-main'>
                  <div className='login-left'>
                    <img className='login-top-img'  src='\assets\bcimages\login\login-top-img.webp'/>
                    <img className='login-top-img-2'  src='\assets\bcimages\login\login-banner-2.webp'/>
                  <img className='login-logo-img' src={process.env.REACT_APP_LG_LOGO} />
                    <CloseButtonNew onClick={this.handleCloseF}>×</CloseButtonNew>
                    <div className='login-content'>
                      <p className='login-content-title'>Stay Untamed</p>
                      <p className='login-content-desc'>Reset password!</p>
                    </div>
                  </div>

                <div className='login-right'>
                    <ModalHeader>
                        <p className='signin-text-header'>Reset password</p>
                        <CloseButton onClick={this.handleCloseF}>×</CloseButton>
                    </ModalHeader>
                    <ModalBody>
                         
                        <StyledForm onSubmit={this.handleForgetSubmit }>

                        <PhoneInputWrapper>
                            <select
                            value={this.state.countryCode}
                            onChange={(e) => this.setState({ countryCode: e.target.value })}
                            style={{
                                padding: "8px",
                                borderRadius: "6px",
                                border: "1px solid #555",
                                background: "#1a1a1a",
                                color: "#fff"
                            }}
                        >
                           {/* <option value="+91">🇮🇳 +91</option> */}
                                {this.state.countryCodeData.map((country) => (
                                    <option key={country.code} value={country.dial_code}>{country?.flag}{country.dial_code}
                                    </option>
                                ))}
                        </select>
                            <StyledInputss
                                type="text"
                                name="phone"
                                value={phone}
                                onChange={this.handleInputChange}
                                placeholder="Phone Number"
                            />
                            {/* <SendOtpButton type="button" onClick={this.handleSendOtp}  disabled={loading}>
                                {loading ? "Sending..." : "Send otp"}
                            </SendOtpButton> */}
                        </PhoneInputWrapper>

                        {/* {isOtp && (
                            <StyledInput
                                type="text"
                                name="otp"
                                value={otp}
                                onChange={this.handleInputChange}
                                placeholder="Enter OTP"
                               
                            />
                        )} */}

                       

                                                  
                           
                           
                            <StyledInput
                                type="password"
                                name="password"
                                value={password}
                                onChange={this.handleInputChange}
                                placeholder="Password"
                            />
                            <StyledInput
                                type="password"
                                name="confirmPassword"
                                value={confirmPassword}
                                onChange={this.handleInputChange}
                                placeholder="Confirm password"
                            />
                           
                            <ButtonContainer>
                                <SignUpButton type="submit" disabled={disabled}>
                                    {disabled && <span className="spinner-grow spinner-grow-sm mr-1" role="status" aria-hidden="true"></span>}
                                    Submit
                                </SignUpButton>
                            </ButtonContainer>
                            <div className="signup-button">
                            Already have an account?
                                <SignInButton ><Link to={"/login"}>Sign In</Link></SignInButton>
                                </div>
                        </StyledForm>
                    </ModalBody>
                 </div>
                </div>
                </StyledModal>
            </>
        );
    }
}

export default ForgetPassword;

